import * as React from 'react';
import styled from 'styled-components';
import { IYado } from '../types';
import t from '../locales';

interface IProps {
  yado: IYado,
}

const View = styled.address`
  margin: 4px 0 8px;
  font-style: normal;
  font-size: 12px;
  display: flex;
  align-items: center;
  &:hover {
    span {
      text-decoration: underline;
    }
  }
  span {
    color: var(--blue600);
  }
  i {
    font-size: 24px;
    color: var(--blue600);
  }
`;

const YadoItemMapLink: React.FC<IProps> = (props) => {
  function handleClick(event: React.MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
  }
  return (
    <View onClick={handleClick}>
      <i className="icon-marker_area_solid" />
      <span>{t.seeMap()}</span>
    </View>
  );
};

export default YadoItemMapLink;
